import { OptionList, TextAnswer } from "./Inputs";
import { GappedPassage } from "./PartContext";
import { ListeningPlayer } from "./ListeningPlayer";

function Question({ part, q, answers, setAnswer, children }) {
  const isText = part.type === "notes";
  return (
    <div className="pt-8 first:pt-0" data-testid={`test-listening-question-${q.number}`}>
      {children}
      <div className="overline mt-4">Question {q.number}</div>
      {isText ? (
        <TextAnswer value={answers[q.id]} number={q.number} autoFocus={false} onChange={(v) => setAnswer(q.id, v)} />
      ) : (
        <>
          <h3 className="text-lg md:text-xl mt-2 text-foreground font-bold leading-snug">{q.prompt}</h3>
          <OptionList options={q.options} value={answers[q.id]} onChange={(v) => setAnswer(q.id, v)} testIdPrefix={`test-listening-q${q.number}`} />
        </>
      )}
    </div>
  );
}

export const ListeningPartStep = ({ step, answers, setAnswer, plays, onPlayed }) => {
  const { part, partNo } = step;
  const clips = part.type === "clips";
  const player = (key, script, url, context, testId) => (
    <ListeningPlayer key={key} script={script} audioUrl={url} context={context} playsUsed={plays[key] || 0} onPlayed={() => onPlayed(key)} testId={testId} />
  );

  return (
    <div data-testid="test-listening-part">
      <div className="mb-6">
        <div className="text-xs font-mono-fig text-muted-foreground" data-testid="test-part-label">
          Part {partNo} · {part.title} · {part.difficulty} · {part.questions.length} questions
        </div>
        <p className="mt-2 text-sm text-foreground/75 max-w-3xl">{part.instructions}</p>
        <p className="mt-1 text-xs text-muted-foreground">You can play each recording up to 3 times.</p>
      </div>

      {!clips && (
        <div className="lg:sticky lg:top-4 z-10 bg-background pb-4 max-w-3xl">
          {player(part.id, part.script, part.audio_url, part.context, "test-listening-player")}
        </div>
      )}

      {part.type === "notes" && (
        <div className="neu-inset rounded-2xl p-6 max-w-3xl mb-4"><GappedPassage part={part} currentNumber={null} answers={answers} /></div>
      )}

      <div className="max-w-3xl divide-y divide-foreground/15 [&>*]:pb-8">
        {part.questions.map((q) => (
          <Question key={q.id} part={part} q={q} answers={answers} setAnswer={setAnswer}>
            {clips && player(q.id, q.script, q.audio_url, q.context, `test-listening-player-${q.number}`)}
          </Question>
        ))}
      </div>
    </div>
  );
};
